/**
 * Comutatorul intrarii cu codul scolii (SP-05b, b24).
 *
 * OPRIT implicit, si citit o singura data, aici. Cat timp e oprit, ruta `/colaborator/cod` nu se
 * inregistreaza deloc si legatura de pe login nu se randeaza — altfel legatura ar cadea pe
 * catch-all si ar arata identic cu o sesiune expirata.
 *
 * 🔴 Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste TEXTUAL
 * `import.meta.env.VITE_...` la build. Forma `(import.meta as {...}).env?.VITE_...` multumeste
 * TypeScript si ramane `undefined` in bundle, deci flagul e mereu oprit — capcana platita deja.
 *
 * ⚠️ `ImportMetaEnv` are `[key: string]: any`, deci un typo in nume compileaza si devine
 * `undefined` la runtime. De-aia numele apare o SINGURA data in cod: aici.
 *
 * ⚠️ Are pereche in backend: `colab.cod-scoala.enabled`. Pornit singur, ecranul primeste
 * 405 (`Allow: GET`) pe `POST /api/collab/cod` — masurat pe PROD de S0 si V1 pe `80ddec65` — adica
 * un ecran care nu poate functiona. Intai backendul.
 */
export const INTRARE_COD_SCOALA_ACTIVA =
    String(import.meta.env.VITE_INTRARE_COD_SCOALA ?? '').toLowerCase() === 'true';
